import { AxiosResponse } from "axios";

import axiosClient from "../apiClient";
import { format } from "date-fns";
import { DATE_FORMAT } from "../utils/appConstants";

// SAGA FLOW EXAMPLE FOR FUTURE API INTEGRATION

export const UserService = async () => {
  try {
    return await axiosClient.get("https://dummyjson.com/users");
  } catch (error) {
    return error;
  }
};

export const getDashboardDataService = async (
  params: {
    startDate: Date;
    endDate: Date;
    platform: string;
    ad_account_id: null | string;
  },
  signal?: AbortSignal
): Promise<AxiosResponse> => {
  try {
    const queryString = `?startDate=${
      params.startDate ? format(new Date(params.startDate), DATE_FORMAT) : ""
    }&endDate=${
      params.endDate ? format(new Date(params.endDate), DATE_FORMAT) : ""
    }&platform=${params.platform}&ad_account_id=${params?.ad_account_id ?? ""}`;

    const response = await axiosClient.get(`dashboard${queryString}`, {
      signal,
    });
    return response.data;
  } catch (error) {
    console.error("Error in getDashboardDataService:", error);
    throw error;
  }
};
